<template>
  <div id="app">
    <transition name="fade">
      <preloader v-if="!isAppLoaded"/>
    </transition>
    <div v-if="isAppLoaded">
      <transition name="fade">
        <modal v-if="isModalOpen"/>
      </transition>
      <transition name="fade">
        <video-modal v-if="isModalVideoOpen"/>
      </transition>
      <transition name="fade">
        <main-menu v-if="isMenuOpen"/>
      </transition>
      <video-static-modal :videoType="modalStaticVideoType"/>
      <main-header/>
      <router-view></router-view>
    </div>
    <canvas-animation/>
    <ScrollTop></ScrollTop>
  </div>
</template>

<script>
  import MainHeader from './components/Header'
  import MainMenu from './components/Menu'
  import Modal from './components/Modal'
  import CanvasAnimation from './components/Canvas';
  import Preloader from './components/Preloader';
  import aos from 'aos';
  import VideoModal from './components/VideoModal'
  import ScrollTop from './components/ScrollTop';
  import store from './store/store';
  import VideoStaticModal from "./components/VideoStaticModal";
  import 'material-design-icons-iconfont/dist/material-design-icons.css'

  export default {
    name: 'app',
    components: {
      MainHeader,
      MainMenu,
      Modal,
      VideoModal,
      CanvasAnimation,
      Preloader,
      ScrollTop,
      VideoStaticModal,
    },
    mounted: () => {
      let t = this;
      window.addEventListener('scroll', (e) => {
        const y = window.scrollY;
        if (store.state.isScrollTopVisible && y === 0) {
          store.commit('SET_SCROLL_TOP_VISIBLE', false)
        } else if (!store.state.isScrollTopVisible && y !== 0) {
          store.commit('SET_SCROLL_TOP_VISIBLE', true)
        }
      })
      aos.init();
      const lang = localStorage['lang']
      if (lang) {
        store.commit('SET_LANG', localStorage.lang);
      }
      const isMenuOpen = store.state.isMenuOpen;
      document.body.classList.toggle('no-scroll', isMenuOpen);
      document.documentElement.classList.toggle('no-scroll', isMenuOpen);
    },
    computed: {
      isHomeAnimActive() {
        return this.$store.state.isHomeAnimActive;
      },
      isAppLoaded() {
        return this.$store.state.isAppLoaded;
      },
      isMenuOpen() {
        return this.$store.state.isMenuOpen;
      },
      isModalOpen() {
        return this.$store.state.isModalOpen;
      },
      isModalVideoOpen() {
        return this.$store.state.isModalVideoOpen;
      },
     modalStaticVideoType() {
      return this.$store.state.modalStaticVideoType;
    }
    },
    watch: {
      isMenuOpen(isOpen) {
        document.body.classList.toggle('no-scroll', isOpen);
        document.documentElement.classList.toggle('no-scroll', isOpen);
      }
    },
    beforeDestroy() {
      document.body.classList.remove('no-scroll');
      document.documentElement.classList.remove('no-scroll');
    },
    // watch: {
    //   '$route' (to, from) {
    //     this.$store.commit('CLOSE_MENU');
    //   }
    // }
  }
</script>

<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0
  }
</style>



// WEBPACK FOOTER //
// App.vue?31582a04